module.exports = __webpack_public_path__ + "static/media/Asset 2_6.75cf4200.png";